
import RankingDesktop from "@/components/child/product/RankingDesktop";
import RankingMobile from "@/components/child/product/RankingMobile";
import { getRankingDataApi } from "@/apis/beauty";

export default {
    data() {
        return {
            screenWidth: 0,
            tab_id: 1,
            tabList: [
                {
                    id: 1,
                    text: "美妝"
                },
                {
                    id: 2,
                    text: "保養"
                }
            ],
            bar_length: ['90%', '80%', '70%', '60%', '50%', '50%', '40%', '30%', '20%', '10%'],
            showAnimation: false,
            makeup_api_data: [],
            care_api_data: [],
            product_ranking_data: [],
            productDataApiTop: {
                articles: [],
                imp: 0,
                imp_ratio: 0,
                name: "",
                popularity: 0,
                popularity_diff: 0
            },
            productDataApiOther: [],
            top_product_article_data: [],
            topNum: 1,
            barNum: ""
        }
    },
    components: {
        RankingDesktop,
        RankingMobile
    },
    methods: {
        setProductRank(data) {
            const vm = this;
            vm.product_ranking_data = data;
            vm.productDataApiTop = data.slice(0, 1)[0];
            vm.productDataApiOther = data.slice(1);
        },
        setTopProductArticle(data) {
            const vm = this;
            vm.top_product_article_data = [];
            setTimeout(() => {
                vm.top_product_article_data = data;
            }, 0);
        },
        activeProductTab(num) {
            const vm = this;
            vm.product_ranking_data = [];
            vm.topNum = 1;
            if (vm.tab_id != num) {
                vm.tab_id = num;
                vm.product_ranking_data = vm.tab_id == 1 ? vm.makeup_api_data : vm.care_api_data;
                if (vm.tab_id == 1) {
                    vm.setProductRank(vm.makeup_api_data);
                    if (vm.makeup_api_data.length > 0) {
                        vm.setTopProductArticle(vm.makeup_api_data[0].articles);
                    }
                } else {
                    vm.setProductRank(vm.care_api_data);
                    if (vm.care_api_data.length > 0) {
                        vm.setTopProductArticle(vm.care_api_data[0].articles);
                    }
                }
            }
        },
        setShowAnimation() {
            const vm = this;
            setTimeout(() => {
                vm.showAnimation = true;
            }, 300)
        },
        async getRankingData() {
            const vm = this;
            await getRankingDataApi().then((res) => {
                const tmpResData = res.data;
                if (tmpResData.success) {
                    const tmpData = tmpResData.data;
                    if (tmpData.category) {
                        vm.care_api_data = tmpData.category["保養"];
                        vm.makeup_api_data = tmpData.category["美妝"];
                        vm.product_ranking_data = vm.makeup_api_data;
                        vm.setProductRank(vm.makeup_api_data);
                        if (vm.makeup_api_data.length > 0) {
                            vm.topNum = 1;
                            vm.setTopProductArticle(vm.makeup_api_data[0].articles);
                        }
                    }
                }
            }).catch(() => {
                console.log("網路傳輸錯誤，請洽客服人員。");
            });
        },
        handleResize() {
            const vm = this;
            vm.screenWidth = window.innerWidth;
        },
        openDetail(dataIndex) {
            const vm = this;
            vm.topNum = parseInt(dataIndex) + 1;
            if (vm.tab_id == 1) {
                vm.productDataApiTop = {
                    articles: vm.makeup_api_data[dataIndex].articles,
                    imp: vm.makeup_api_data[dataIndex].imp,
                    imp_ratio: vm.makeup_api_data[dataIndex].imp_ratio,
                    name: vm.makeup_api_data[dataIndex].name,
                    popularity: vm.makeup_api_data[dataIndex].popularity,
                    popularity_diff: vm.makeup_api_data[dataIndex].popularity_diff
                };
                if (vm.makeup_api_data.length > 0) {
                    vm.setTopProductArticle(vm.makeup_api_data[dataIndex].articles);
                }
            } else if (vm.tab_id == 2) {
                vm.productDataApiTop = {
                    articles: vm.care_api_data[dataIndex].articles,
                    imp: vm.care_api_data[dataIndex].imp,
                    imp_ratio: vm.care_api_data[dataIndex].imp_ratio,
                    name: vm.care_api_data[dataIndex].name,
                    popularity: vm.care_api_data[dataIndex].popularity,
                    popularity_diff: vm.care_api_data[dataIndex].popularity_diff
                };
                if (vm.care_api_data.length > 0) {
                    vm.setTopProductArticle(vm.care_api_data[dataIndex].articles);
                }
            }
        }
    },
    async fetch() {
        const vm = this;
        await vm.getRankingData()
    },
    mounted() {
        const vm = this;
        window.addEventListener("resize", vm.handleResize);
        vm.handleResize();
        vm.setShowAnimation();
    },
    beforeDestroy() {
        const vm = this;
        window.removeEventListener("resize", vm.handleResize);
    }
}
